export class RefForme {
    id: number;
    code: string;
    libelle: string;
}
